import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchStockAdjustmentDetail(id) {
  const { data: raw } = await request.get(`/ims/stock-adjustment/${id}`);
  return parseVer4DetailResponse(raw);
}
